import React from "react";
import { clsxm } from "../../../utils/clxm/clxm";

export type Option = {
  label: string | React.ReactElement;
  value: string | number;
  selectedLabel?: string | React.ReactElement;
  isHeader?: boolean;
};

export type PSelectOption = {
  onSelect: (value: string | number) => void;
  option: Option;
  isActive: boolean;
  styles?: React.CSSProperties;
  getOptionCls?: (isActive: boolean) => string;
  onExpandedChange?: (expanded: boolean) => void;
};

export const OPTION_FONT_CLS = "text-[12px]";

export const SelectOption: React.FC<PSelectOption> = (props) => {
  const { onSelect, option, isActive, styles, getOptionCls, onExpandedChange } =
    props;

  const handleClick = () => {
    if (option.isHeader) {
      return;
    }
    onSelect(option.value);
    onExpandedChange?.(false);
  };

  if (option.isHeader) {
    return (
      <div key={option.value} style={styles} className="cursor-default">
        {option.label}
      </div>
    );
  }

  return (
    <div
      key={option.value}
      onClick={handleClick}
      style={styles}
      className={clsxm(
        "px-[10px] flex py-[8px] text-text-base gap-2 last:rounded-b-lg cursor-pointer relative items-center hover:bg-bg-base",
        OPTION_FONT_CLS,
        isActive && "border-l-[2px] border-l-border-button-primary",
        getOptionCls && getOptionCls(isActive)
      )}
    >
      {option.label}
    </div>
  );
};
